export default {
  props: {
    item: Object,
  },
  computed: {
    isExternal() {
      return this.item.url && this.item.url.includes('://')
    },
  },
}
